var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWreath(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 16.7833L18.1765 15.5599L19.3632 17.5699L21.9432 17.4666L21.8232 19.7233L24.1199 20.7633L22.7265 22.6666L24.1199 24.5699L21.8232 25.6099L21.9432 27.8699L19.3632 27.7633L18.1765 29.7733L15.9999 28.5533L13.8232 29.7733L12.6365 27.7633L10.0565 27.8699L10.1765 25.6099L7.87988 24.5699L9.27322 22.6666L7.87988 20.7633L10.1765 19.7233L10.0565 17.4666L12.6365 17.5699L13.8232 15.5599L15.9999 16.7833Z",
    fill: "white",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.4733L17.88 10.3633L18.9066 12.1866L21.14 12.0933L21.0366 14.1433L23.02 15.0866L21.8133 16.8166L23.02 18.5433L21.0366 19.4866L21.14 21.5399L18.9066 21.4433L17.88 23.2666L16 22.1599L14.12 23.2666L13.0933 21.4433L10.86 21.5399L10.9633 19.4866L8.97998 18.5433L10.1866 16.8166L8.97998 15.0866L10.9633 14.1433L10.86 12.0933L13.0933 12.1866L14.12 10.3633L16 11.4733Z",
    fill: "white",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 5.82326L17.7099 4.75659L18.6433 6.50993L20.6733 6.41993L20.5799 8.39326L22.3866 9.29992L21.2899 10.9633L22.3866 12.6299L20.5799 13.5366L20.6733 15.5099L18.6433 15.4199L17.7099 17.1733L15.9999 16.1066L14.2899 17.1733L13.3566 15.4199L11.3266 15.5099L11.4199 13.5366L9.61328 12.6299L10.7099 10.9633L9.61328 9.29992L11.4199 8.39326L11.3266 6.41993L13.3566 6.50993L14.2899 4.75659L15.9999 5.82326Z",
    fill: "white",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2803 6.02002L24.9403 27.6534",
    stroke: "#C9906A",
    strokeWidth: 3,
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7267 6.02002L7.06006 27.66",
    stroke: "#C9906A",
    strokeWidth: 3,
    strokeLinejoin: "bevel"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.19995C17.6569 8.19995 19 6.85681 19 5.19995C19 3.5431 17.6569 2.19995 16 2.19995C14.3431 2.19995 13 3.5431 13 5.19995C13 6.85681 14.3431 8.19995 16 8.19995Z",
    fill: "#1F2937",
    stroke: "#C9906A",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWreath);
export default __webpack_public_path__ + "static/media/icon-wreath.991a6fd867b6a65e785f2e8bf1ad8b16.svg";
export { ForwardRef as ReactComponent };